import React, { useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import {
  Box,
  Button,
  Flex,
  Grid,
  Label,
  FileUpload,
  ErrorMsg,
  Toastify,
} from "atoms";
import { FormCheckbox, FormInput } from "molecules/FormInput";
import { optionFetch } from "utils/utilities";
import { usePropsoch } from "contexts/Propsoch";
import { useParams } from "react-router-dom";

export const AmenitiesForm = ({
  onNext,
  onPrevious,
  bindHitOnSave,
  fetchProperty,
  rootProperty,
}) => {
  const {
    actions: {
      getPropertyListingAmenities,
      createPropertyListingAmenities,
      updatePropertyListingAmenities,
    },
  } = usePropsoch();

  const { id } = useParams();

  // fetch property
  const [property, setProperty] = useState(null);

  useEffect(() => {
    id &&
      getPropertyListingAmenities(id)?.then((data) => {
        setProperty(data);

        // reformat type
        // data &&
        //   setProperty((prev) => ({
        //     ...prev,
        //     amenityIds: data?.amenities,
        //   }));
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // submit
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = useCallback(
    ({
      amenityIds,
      images,
      // totalNumberOfCourts,
      // numberOfIndoorCourts,
      // numberOfOutdoorCourts,
      clubHouseArea,
      numberOfClubHouse,
      amenityComments,
      dirty,
    }) => {
      setSubmitLoading(true);
      if (dirty) {
        const formattedValues = {
          propertyId: id,
          amenityIds,
          images,
          // totalNumberOfCourts,
          // numberOfIndoorCourts,
          // numberOfOutdoorCourts,
          clubHouseArea,
          numberOfClubHouse,
          amenityComments,
        };

        if (property) {
          updatePropertyListingAmenities(
            { ...formattedValues },
            id,
            rootProperty?.name
          )
            .then(() => {
              Toastify("success", "Amenities updated");
              fetchProperty()?.then(() => {
                onNext();
              });
            })
            .catch((e) => {
              Toastify("error", "Amenities not updated");
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        } else {
          createPropertyListingAmenities(formattedValues, rootProperty?.name)
            .then(() => {
              Toastify("success", "Amenities created");
              fetchProperty()?.then(() => {
                onNext();
              });
            })
            .catch((e) => {
              Toastify("error", "Amenities not created");
            })
            .finally(() => {
              setSubmitLoading(false);
            });
        }
      } else {
        if (id) {
          onNext();
        }
      }
    },
    [
      createPropertyListingAmenities,
      id,
      updatePropertyListingAmenities,
      onNext,
      property,
      rootProperty,
      fetchProperty,
    ]
  );

  // amenities
  const [amenities, setamenities] = useState([]);
  useEffect(() => {
    // status
    optionFetch("/amenities/get", "name", "id").then((data) => {
      setamenities(data);
    });
  }, []);

  const validationSchema = Yup.object().shape({
    amenityIds: Yup.array()
      // .of(Yup.string())
      .min(1, "Choose a amenity")
      .typeError("Amenities is required")
      .required("Amenities is required"),
    // totalNumberOfCourts: Yup.number().required(
    //   "total number of courts is required"
    // ),
    // numberOfIndoorCourts: Yup.number().required("indoor court is required"),
    // numberOfOutdoorCourts: Yup.number().required("outdoor court is required"),
    clubHouseArea: Yup.number()
      .min(0, "Value should be greater than 0")
      .typeError("Invalid number")
      .required("club house is required"),
    numberOfClubHouse: Yup.number()
      .min(0, "Value should be greater than 0")
      .typeError("Invalid number")
      .required("club house/ apartment is required"),
    amenityComments: Yup.string()
      .nullable()
      .when("amenityIds", {
        is: (v) =>
          [...v]?.filter((i) =>
            amenities
              ?.find((t) => t?.value === i)
              ?.label?.toLowerCase()
              ?.includes("other")
          )?.length > 0,
        then: Yup.string().required("Add comments"),
      }),
  });

  return (
    <Formik
      initialValues={
        property
          ? property
          : {
              amenityIds: [],
              totalNumberOfCourts: "",
              numberOfIndoorCourts: "",
              numberOfOutdoorCourts: "",
              clubHouseArea: "",
              numberOfClubHouse: "",
              images: [],
            }
      }
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {({ values, setFieldValue, submitForm, dirty, touched, errors }) => {
        bindHitOnSave(() => {
          setFieldValue("dirty", dirty);
          submitForm();
        });
        return (
          <Form>
            <Grid gridGap="3.2rem" mt="2.4rem">
              <Grid gridGap="2.4rem">
                <Label text="Amenities" req />
                <Flex gridGap="3rem" flexWrap="wrap">
                  {amenities?.map((item, index) => (
                    <FormCheckbox
                      key={index}
                      name="amenityIds"
                      height="1.8rem"
                      value={item?.value}
                      label={item?.label}
                    />
                  ))}
                </Flex>
                {touched?.amenityIds && errors?.amenityIds && (
                  <ErrorMsg text={errors?.amenityIds} />
                )}
              </Grid>
              {[...(values?.amenityIds || [])]?.filter((i) =>
                amenities
                  ?.find((t) => t?.value === i)
                  ?.label?.toLowerCase()
                  ?.includes("other")
              )?.length > 0 && (
                <Grid gridTemplateColumns="1fr 1fr" gridGap="2.4rem">
                  <Grid gridRowGap="1.6rem">
                    <Label text="Comments" req />
                    <FormInput
                      name="amenityComments"
                      type="text"
                      placeholder="Enter Comments"
                      req
                    />
                  </Grid>
                </Grid>
              )}
              {/* <Grid gridTemplateColumns="1fr 1fr" gridGap="2.4rem">
                <Grid gridRowGap="1.6rem">
                  <Label text="Total number of courts" req />
                  <FormInput
                    name="totalNumberOfCourts"
                    type="number"
                    placeholder="Enter Number"
                    req
                  />
                </Grid>
                <Grid gridRowGap="1.6rem">
                  <Label text="No. of indoor court" req />
                  <FormInput
                    name="numberOfIndoorCourts"
                    type="number"
                    placeholder="Enter Number"
                    req
                  />
                </Grid>
                <Grid gridRowGap="1.6rem">
                  <Label text="No. of Outdoor court" req />
                  <FormInput
                    name="numberOfOutdoorCourts"
                    type="number"
                    placeholder="Enter Number"
                    req
                  />
                </Grid>
              </Grid> */}

              <Grid gridTemplateColumns="1fr 1fr" gridGap="2.4rem">
                <Grid gridRowGap="1.6rem">
                  <Label text="Club House" req />
                  <FormInput
                    name="clubHouseArea"
                    // type="number"
                    placeholder="Enter Sq.Ft."
                    req
                  />
                </Grid>
                <Grid gridRowGap="1.6rem">
                  <Label text="Club house/ Apartment" req />
                  <FormInput
                    name="numberOfClubHouse"
                    // type="number"
                    placeholder="Enter Number"
                    req
                  />
                </Grid>
              </Grid>

              <Box>
                <Label text="Upload Amenities Images" mb="1.6rem" />
                <FileUpload
                  files={values?.images || []}
                  onUpload={(locations) => {
                    const newProjectImages = [
                      ...(values?.images
                        ? JSON.parse(JSON.stringify(values?.images)) || []
                        : []),
                      ...locations?.map((i) => ({ image: i, alt: "" })),
                    ];

                    setFieldValue("images", newProjectImages);
                  }}
                  onSubmitDescription={({ alt, file }) => {
                    setFieldValue(`images.[${file?.index}].alt`, alt);
                  }}
                  onCross={(index) => {
                    const currProjectImages = [
                      ...(values?.images
                        ? JSON.parse(JSON.stringify(values?.images)) || []
                        : []),
                    ];
                    const total = currProjectImages?.length;

                    const newProjectImages = [
                      ...currProjectImages?.slice(0, index),
                      ...currProjectImages?.slice(index + 1, total),
                    ];

                    setFieldValue("images", newProjectImages);
                  }}
                />
              </Box>

              <Flex my="2rem" gridGap="1.6rem">
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primaryOutline"
                  height="4.8rem"
                  onClick={onPrevious}
                >
                  Previous
                </Button>
                <Button
                  px="3rem"
                  width="fit-content"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                  loading={submitLoading}
                  onClick={() => {
                    setFieldValue("dirty", dirty);
                    submitForm();
                  }}
                >
                  Next
                </Button>
              </Flex>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};
